module.exports = __webpack_public_path__ + "img/cover.3f0d8783.jpg";